/**
 * @fileoverview LoginDisplay component for user authentication using Kinde Auth
 * @requires react
 * @requires @kinde-oss/kinde-auth-react
 */

import React from "react"
import DataQButton from "shared/ui/Buttons/DataQButton.component"
import { useKindeAuth } from "@kinde-oss/kinde-auth-react"

/**
 * LoginDisplay component displays the login and registration buttons using Kinde authentication.
 * Provides a clean interface for users to sign in to the application.
 */
const LoginDisplay: React.FC = () => {
  const {
    login,
    // register // Commented out - can be enabled if registration is needed
  } = useKindeAuth()

  /**
   * Handles the login button click
   */
  const handleLogin = (): void => {
    login()
  }

  /**
   * Handles the register button click (currently disabled)
   */
  // const handleRegister = (): void => {
  //   register()
  // }

  return (
    <div className="flex flex-col h-full">
      {/* Logo Section */}
      <div className="mb-3">
        <img
          src="/assets/images/data-q-logo-black-n-blue.png"
          alt="Data Q Logo"
          className="w-60"
        />
      </div>

      {/* Authentication Buttons */}
      <div className="flex flex-col space-y-2">
        {/* Registration Button - Currently Disabled */}
        {/* <DataQButton 
          type="primary" 
          className="h-10 w-full" 
          onClick={handleRegister}
          aria-label="Sign up for a new account"
        >
          Sign up
        </DataQButton> */}

        {/* Login Button */}
        <DataQButton
          type="primary"
          className="h-10 w-full"
          onClick={handleLogin}
          aria-label="Sign in to your account"
        >
          Sign In
        </DataQButton>
      </div>
    </div>
  )
}

export default LoginDisplay
